import React, {useEffect, useRef, useState} from 'react';
import {auth, db} from "../../services/firebase";
import {ChatContent, ChatTitle, Main} from "../../components";
import UserItem from "../../components/user-item/user-item";
import ChatBody from "../../components/chat-body/chat-body";
import {useTranslation} from 'react-i18next';
import {StartChatButton} from './group-chat.styles';
import Notification from "../../helpers/notifications";

const GroupChat = () => {

    const [chats, setChats] = useState([]);
    const [onlineUsers, setOnlineUsers] = useState([]);
    const [openInMobile, setOpenInMobile] = useState(false);
    const chatBodyRef = useRef(null);

    const [t] = useTranslation();

    useEffect(() => {

        (async () => {
            try {
                db.ref('global_chat').limitToLast(20).on('value', snapshot => {
                    const newChats = [];
                    snapshot.forEach((snap) => {
                        newChats.push(snap.val());
                    })
                    setChats(newChats);

                    const element = chatBodyRef.current;
                    element.scrollTo(0, element.scrollHeight+300);
                });

                db.ref('users').orderByChild('online').limitToLast(20).equalTo(true)
                    .on('value', snapshot => {
                        const newOnlineUsers = [];
                        snapshot.forEach((snap) => {
                            if (snap.val().uid !== auth().currentUser.uid)
                                newOnlineUsers.push(snap.val());
                        })
                        setOnlineUsers(newOnlineUsers);
                    });
            } catch (e) {
                Notification.danger(e.message)
            }
        })();
    }, []);

    const onSendMessage = async (message) => {
        if (message.trim() === "") {
            Notification.danger('پیام نمی تواند خالی باشد');
            return false;
        }
        try {
            const {email, displayName, photoURL, uid} = auth().currentUser;
            await db.ref('global_chat').push({
                message,
                from: {
                    uid,
                    displayName,
                    email,
                    photoURL
                },
                to: 'all',
                timestamp: new Date().getTime()
            })
        } catch (e) {
            Notification.danger(e.message)
        }
    }

    return (
        <Main userSecTitle={t('group chat users title')}
              userSecAction={() => <StartChatButton className='btn d-xl-none' onClick={() => setOpenInMobile(true)}>
                  {t('Start chat')}
              </StartChatButton>}
              userSecChildren={(() => {
                  return <>
                      {
                          onlineUsers.map((item, index) =>
                              <UserItem
                                  key={index}
                                  imageSource={item.photoURL}
                                  userName={item.displayName}
                                  userStatus={item.online ? 'online' : 'offline'}
                                  lastMessage='I’m working hard in Maths, Physics and Chemistry. I have planning to appear in I.I.T. after XII.'/>
                          )
                      }
                  </>

              })()}>
            <ChatBody inputPlaceholder={t('write')}
                      chatBodyRef={chatBodyRef}
                      onSendMessage={onSendMessage}
                      openInMobile={openInMobile}>
                <ChatTitle classes='d-flex align-items-center justify-content-between'>
                    <p className='mb-0'>{t('group chat title')}</p>
                    <button className='simple-btn d-xl-none' onClick={() => setOpenInMobile(false)}>
                        <i className="fas fa-chevron-left main-text-color"/>
                    </button>
                </ChatTitle>
                <div className='px-4 pb-2'>
                    {
                        chats.length > 0 ? chats.map((item, index) =>
                                <ChatContent key={index}
                                             isSelf={item.from.uid === auth().currentUser.uid}
                                             message={item.message}
                                             timestamp={item.timestamp}
                                             avatarSource={item.from.photoURL}
                                             nickName={item.from.displayName}/>
                            ) :
                            <p className='my-3 text-center'>{t('no conversation')}</p>
                    }
                </div>
            </ChatBody>
        </Main>
    );
};

export default GroupChat;
